<template>
  <b-modal
    :active.sync="isModalActive"
    :width="640"
    scroll="keep"
    :on-cancel="cancelSubmit"
  >
    <div class="flex flex-col p-4 bg-white border rounded shadow border-blue-light">

      <div class="flex flex-col w-full">
        <div class="font-semibold uppercase text-blue">
          {{ $t('edit') }} {{ $t('executed_quantity') }}
        </div>
      </div>
      <!-- task -->
      <form v-if="assignmentType == 'task'"
       @submit.prevent="submitForm"
       class="w-full">
        <div class="flex flex-row w-full mt-4 gap-4">

          <!-- executed_quantity -->
          <div class="flex flex-col flex-1">
            <label class="text-xs font-medium text-blue">{{ $t("executed_quantity") }}</label>
            <input
              v-model.number="executed_quantity"
              type="number"
              min="0"
              step="any"
              class="w-full p-2 text-xs border rounded bg-grey-lighter border-grey-light"
            />
          </div>
          <!-- total assignment progress -->
          <div class="flex flex-col flex-1">
            <label class="text-xs font-medium text-blue">{{ assignmentLine.status == 0 ? $t("progress") : $t("actual_progress") }}</label>
            <input
              v-if="assignmentLine.status == 0"
              v-model.number="assignmentProgress"
              type="number"
              min="0"
              class="w-full p-2 text-xs border rounded bg-grey-lighter border-grey-light"
              disabled
            />
            <input
              v-else
              v-model.number="assignmentActualProgress"
              type="number"
              min="0"
              class="w-full p-2 text-xs border rounded bg-grey-lighter border-grey-light"
              disabled
            />
          </div>
        </div>

        <!-- Edición de fechas: sólo administrador del proyecto -->
        <div v-if="canEditDates" class="mt-4 pt-4 border-t border-grey-lighter">
          <div class="mb-2 text-xs italic text-grey-dark">{{ $t("date_range") }}</div>
          <div class="flex flex-row w-full gap-4">
            <div class="flex flex-col flex-1">
              <label class="text-xs font-medium text-blue">{{ $t("start_date") }}</label>
              <input
                v-model="start_date"
                type="date"
                required
                class="w-full p-2 text-xs border rounded bg-grey-lighter border-grey-light"
              />
            </div>
            <div class="flex flex-col flex-1">
              <label class="text-xs font-medium text-blue">{{ $t("end_date") }}</label>
              <input
                v-model="end_date"
                type="date"
                required
                :min="start_date"
                class="w-full p-2 text-xs border rounded bg-grey-lighter border-grey-light"
              />
            </div>
          </div>
        </div>

        <div class="flex flex-row items-center justify-end w-full mt-6 gap-2">
          <div v-if="isLoading" class="mr-2">
            <scale-loader />
          </div>
          <button
            @click.prevent="cancelSubmit"
            :disabled="isLoading"
            class="btn btn-red"
            type="button"
            >
            {{ $t("cancel") }}
          </button>
          <button class="btn btn-blue" type="submit" :disabled="isLoading">{{ $t("save") }}</button>
        </div>
      </form>

      <!-- resource -->
      <form v-else
        @submit.prevent="submitForm"
        class="w-full">
        <div class="flex flex-row w-full mt-4 gap-4">
          <!-- executed_quantity -->
          <div class="flex flex-col flex-1">
            <label class="text-xs font-medium text-blue">{{ $t("executed_quantity") }}</label>
            <input
              v-model.number="executed_quantity"
              type="number"
              min="0"
              step="any"
              class="w-full p-2 text-xs border rounded bg-grey-lighter border-grey-light"
            />
          </div>
        </div>

        <!-- Edición de fechas: sólo administrador del proyecto -->
        <div v-if="canEditDates" class="mt-4 pt-4 border-t border-grey-lighter">
          <div class="mb-2 text-xs italic text-grey-dark">{{ $t("date_range") }}</div>
          <div class="flex flex-row w-full gap-4">
            <div class="flex flex-col flex-1">
              <label class="text-xs font-medium text-blue">{{ $t("start_date") }}</label>
              <input
                v-model="start_date"
                type="date"
                required
                class="w-full p-2 text-xs border rounded bg-grey-lighter border-grey-light"
              />
            </div>
            <div class="flex flex-col flex-1">
              <label class="text-xs font-medium text-blue">{{ $t("end_date") }}</label>
              <input
                v-model="end_date"
                type="date"
                required
                :min="start_date"
                class="w-full p-2 text-xs border rounded bg-grey-lighter border-grey-light"
              />
            </div>
          </div>
        </div>

        <div class="flex flex-row items-center justify-end w-full mt-6 gap-2">
          <div v-if="isLoading" class="mr-2">
            <scale-loader />
          </div>
          <button
            @click.prevent="cancelSubmit"
            :disabled="isLoading"
            class="btn btn-red"
            type="button"
            >
            {{ $t("cancel") }}
          </button>
          <button class="btn btn-blue" type="submit" :disabled="isLoading">{{ $t("save") }}</button>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";

import EventBus from "~/plugins/bus";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";

export default {
  name: "assignment-line-edit-modal",

  components: {
    ScaleLoader,
  },

  props: {
    entityId: { type: Number, required: true },
    entityType: { type: String, required: true },
    filterUploadType: {
      type: Object,
      default: () => ({ filter: false }),
      required: false,
    },
  },

  data: () => ({
    isModalActive: false,
    id: null,
    assignmentId: null,
    assignmentType: null, // resource or task
    executed_quantity: 0,
    assignment: null,
    asignmentLine: null,
    assignmentProgress: 0,
    assignmentActualProgress: 0,
    isLoading: false,
    start_date: null,
    end_date: null,
    originalStartDate: null,
    originalEndDate: null,
  }),

  computed: {
    ...mapGetters({
      project: "app/project",
    }),
    canEditDates() {
      return !!(this.project && this.project.can_admin);
    },
  },

  watch: {
    executed_quantity(value) {
      const originalExecutedLine = this.assignmentLine.executed_quantity || 0;
      if (this.assignmentLine.status == 0 && this.assignmentType == 'task') { // inspected
        const originalInspectedProgress = this.assignment.executed_quantity || 0;
        this.assignmentProgress = originalInspectedProgress + (value - originalExecutedLine);
      }

      if (this.assignmentLine.status == 10 && this.assignmentType == 'task'){ // actual progress
        const originalActualProgress = this.assignment.actual_progress || 0;
        this.assignmentActualProgress = originalActualProgress + (value - originalExecutedLine);
      }
    },
  },

  methods: {

    /**
     * Cancelamos el envio del formulario y refrescamos la lista
     * para quitar check
     */
    cancelSubmit() {
      this.$emit("reload");
      this.hide();
    },
    /**
     * Envía el formulario para completarlo
     */
    async submitForm() {
      let url = "/api/v2/assignment/" + this.assignmentId + "/line/" + this.id;

      let data = {
        executed_quantity: this.executed_quantity,
      };

      // Sólo enviamos fechas si el admin las cambió respecto al original
      if (this.canEditDates) {
        if (this.start_date !== this.originalStartDate) {
          data.start_date = this.start_date;
        }
        if (this.end_date !== this.originalEndDate) {
          data.end_date = this.end_date;
        }
      }

      axios
        .put(url, data)
        .then( (response) => {
          if (response.data.success) {
            this.$notify.success("updated_successfully");
            this.$emit("reload");
            EventBus.$emit("refreshActivityDocumentsNotifications", true);
          } else {
            this.$notify.error(response.data.error);
            this.cancelSubmit();
          }
        })
        .catch((error) => {
          this.$notify.error("update_error");
          this.cancelSubmit();
        }).finally(() => {
          this.isLoading = false;
        });

      this.hide();
      this.$emit("reload");
    },

    /**
     * Muestra este modal
     */
    show(assignmentLine, assignment) {
      this.id = assignmentLine.id;
      this.assignmentId = assignment.id;
      this.assignmentType = assignment.type; // resource or task
      this.isModalActive = true;
      this.executed_quantity = assignmentLine.executed_quantity || 0;
      this.assignmentProgress = assignment.executed_quantity || 0;
      this.assignmentActualProgress = assignment.actual_progress || 0;
      this.assignment = assignment;
      this.assignmentLine = assignmentLine;
      // Normalizamos a YYYY-MM-DD para el input type="date"
      this.start_date = assignmentLine.start_date
        ? moment(assignmentLine.start_date).format("YYYY-MM-DD")
        : null;
      this.end_date = assignmentLine.end_date
        ? moment(assignmentLine.end_date).format("YYYY-MM-DD")
        : null;
      this.originalStartDate = this.start_date;
      this.originalEndDate = this.end_date;
    },

    /**
     * Oculta este modal
     */
    hide() {
      this.id = null;
      this.isModalActive = false;

    },
  },
};
</script>
<style scoped>
/* Oculta los botones para aumentar los inputs numéricos */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>
